<template>
  <div>
    <v-text-field
      :class="{ 'is-invalid': !isValidate, css }"       
      :disabled="dis"
      v-model="selectedValue"
      @input="onSelect()"
      :outlined="outlined"
      :dense="dense"
      :rules="urlRules"
    />   
  </div>
</template>
<style scoped>
</style>
<script>
export default {
  props: [
    "value",
    "dis",
    "copyfrom_sourcefield",
    "copyfrom_title",
    "onchangedcallbackparam",
    "css",
    "outlined",
    "dense",
    "isRequired"         
  ],
  data() {
    return {
      selectedValue: this.value,
      expression:"(?:https?):\\/\\/(\\w+:?\\w*)?(\\S+)(:\\d+)?(\\/|\\/([\\w#!:.?+=&%!\\-\\/]))?", 
      urlRules:[
        v => !this.isRequired || (!!v || ''),
        v => (!this.isRequired && (!v || v.trim().length == 0)) || 
        (new RegExp(this.expression)).test(v) || 
        this.$t("errors.Invalid_Url")
      ]
    };
  },
  computed: {
    isValidate() {
      return this.validateUrl();
    }
  },
  watch: {
    value(n, o) {
      this.selectedValue = n;
    }
  },
  methods: {
    onSelect() {
      if (this.selectedValue == "") {
        this.$emit("input", this.selectedValue);
        return;
      }
      var isvalid = this.validateUrl();
      if (isvalid) {
        this.$emit("input", this.selectedValue);
      }
      try {
        this.$emit("onchangedisvalidcallback", isvalid);
      } catch (e) {
        // ignore
      }
    },
    validateUrl() {      
      if (!this.selectedValue) {        
        return true;
      } else {       
        return (new RegExp(this.expression)).test(this.selectedValue);
      }
    },
    onCopyFrom() {
      try {
        this.selectedValue = this.copyfrom_sourcefield;
        this.$emit("input", this.selectedValue);
      } catch (e) {
        // ignore
      }
    }
  }  
};
</script>
